import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams, redirect } from 'react-router-dom';
import MainLayout from '../../components/layout/Main';
import { PublicFeedIcon, YourPostsIcon } from '../../components/elements/icons/Icons';
import './Posts.css';
import Container from 'reactstrap/es/Container';
import FilterQuestionBar from '../../components/post/elements/FilterQuestionBar';
import { usePost } from './usePost';
import { If, Then, Else, When } from 'react-if';
import { Loader } from '../../components/elements/loader/Loader';
import Post from './components/Post';
import SignInModalForm from '../../components/elements/customModals/SignInModalForm/SignInModalForm';
import { useToggle } from 'react-use';
import ForgotPassword from '../../components/elements/customModals/ForgotPassword';
import SignUpModalForm from '../../components/elements/customModals/SignUpModalForm/SignUpModalForm';
import { useAuth } from '../../hooks/useAuth';
import { POSTS } from '../../constants/routes';

const PostsPreview = () => {
    const { isGuest } = useAuth();

    useEffect(() => {
        if (!isGuest) {
            redirect(POSTS);
        }
    }, []);

    const menuRenderer = useCallback(
        () => (
            <>
                <p className="main-layout__nav-link nav-headline">POSTS</p>
                <div className="btn btn-link main-layout__nav-link">
                    <PublicFeedIcon />
                    <p>Invitations</p>
                </div>
                <div className="btn btn-link main-layout__nav-link">
                    <YourPostsIcon />
                    <p>Your Posts</p>
                </div>
            </>
        ),
        []
    );

    const [isSignInModalOpens, toggleSignInModal] = useToggle(false);
    const [isForgotPasswordModalOpens, toggleForgotPasswordModal] = useToggle(false);
    const [isSignUpModalOpens, toggleSignUpModal] = useToggle(false);

    const { id: postId } = useParams();

    const { post, isLoading } = usePost(postId);

    const emptyHandler = useCallback(() => {}, []);

    const handleReviewButtonClick = useCallback(() => {
        toggleSignInModal();
    }, [toggleSignInModal]);

    const handleSignUpButtonClick = useCallback(() => {
        toggleSignUpModal();
        toggleSignInModal();
    }, [toggleSignUpModal, toggleSignInModal]);

    const handleForgotPassButtonClick = useCallback(() => {
        toggleForgotPasswordModal();
        toggleSignInModal();
    }, [toggleForgotPasswordModal, toggleSignInModal]);

    const handleSignInButtonClick = useCallback(() => {
        toggleSignInModal();
        toggleForgotPasswordModal();
    }, [toggleSignInModal, toggleForgotPasswordModal]);

    return (
        <MainLayout menuRenderer={menuRenderer} isPreview={true}>
            <Container fluid={true} className="posts__container">
                <FilterQuestionBar
                    isPreview={true}
                    activeCategory={null}
                    categoryToggle={emptyHandler}
                />
                <If condition={isLoading}>
                    <Then>
                        <Loader />
                    </Then>
                    <Else>
                        {() => (
                            <Post
                                measure={emptyHandler}
                                index={0}
                                style={{}}
                                id={post.uid}
                                title={post.title}
                                media={post.media}
                                description={post.description}
                                categoryId={post.category}
                                createdTimestamp={post.createdTimestamp}
                                firstName={post.user ? post.user.firstName : ''}
                                lastName={post.user ? post.user.lastName : ''}
                                totalDonations={post.totalDonations}
                                questionType={post.question.type}
                                rawPost={post}
                                questions={post.question.questions}
                                publisherUid={post.publisherUid}
                                isApprovedByAdmin={post.isApprovedByAdmin}
                                onReviewsOpen={emptyHandler}
                                isPreview={true}
                                approvedMode={false}
                                onRefresh={emptyHandler}
                                onReviewButtonClick={handleReviewButtonClick}
                            />
                        )}
                    </Else>
                </If>
            </Container>
            <When condition={isSignInModalOpens}>
                {() =>
                    isSignInModalOpens && (
                        <SignInModalForm
                            toggle={toggleSignInModal}
                            modal={isSignInModalOpens}
                            previewPostUid=""
                            redirectToSignUp={handleSignUpButtonClick}
                            redirectToForgotPassword={handleForgotPassButtonClick}
                        />
                    )
                }
            </When>
            <When condition={isForgotPasswordModalOpens}>
                {() =>
                    isForgotPasswordModalOpens && (
                        <ForgotPassword
                            modal={isForgotPasswordModalOpens}
                            toggle={toggleForgotPasswordModal}
                            redirectToSignIn={handleSignInButtonClick}
                        />
                    )
                }
            </When>
            <When condition={true}>
                {() =>
                    isSignUpModalOpens && (
                        <SignUpModalForm
                            toggle={toggleSignUpModal}
                            modal={isSignUpModalOpens}
                            previewPostUid=""
                            inviteCode=""
                            invitationKey=""
                        />
                    )
                }
            </When>
        </MainLayout>
    );
};

PostsPreview.propTypes = {};

export default React.memo(PostsPreview);
